<template>
  <v-icon
    v-tooltip="accountStateUi.message"
    :icon="accountStateUi.icon"
    :color="accountStateUi.color"
  />
</template>

<script lang="ts" setup>
import { useAccountState } from "@/composables/useAccountState";
import type { Account } from "@aircap/common/account";
import { computed } from "vue";

const props = defineProps<{
  account?: Account;
}>();

const { accountStateUi } = useAccountState(computed(() => props.account));
</script>
